import React from "react";

interface PriceDollarIconProps {
  color?: string;
}

export const PriceDollarIcon = ({ color = "#2E7D32" }: PriceDollarIconProps) => (
  <svg
    width="11"
    height="14"
    viewBox="0 0 11 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      d="M5.49984 0.333008V13.6663M8.83317 2.75701H3.83317C3.21433 2.75701 2.62084 3.00284 2.18325 3.44043C1.74567 3.87801 1.49984 4.4715 1.49984 5.09034C1.49984 5.70918 1.74567 6.30267 2.18325 6.74025C2.62084 7.17784 3.21433 7.42367 3.83317 7.42367H7.1665C7.78534 7.42367 8.37883 7.6695 8.81642 8.10709C9.254 8.54467 9.49984 9.13815 9.49984 9.75699C9.49984 10.3758 9.254 10.9693 8.81642 11.4069C8.37883 11.8445 7.78534 12.0903 7.1665 12.0903H1.49984"
      stroke={color}
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
